// The route table of the app: every address and the screen it opens. Registered once by main.ts; the screen tests
// (apps/web/test/screens.test.ts) mount every route listed here.
import { route } from './router.js';
import * as home from './screens/home.js';

export function registerRoutes() {
  // Every screen but the dashboard is its own chunk, loaded the first time it opens (ui/router.ts); the ride itself
  // loads with the first race (ui/ride/start.ts).
  const play = () => import('./screens/play.js');
  const online = () => import('./screens/online.js');
  const events = () => import('./screens/events.js');
  const training = () => import('./screens/training.js');
  const activities = () => import('./screens/activities.js');
  const leaderboards = () => import('./screens/leaderboards.js');
  const friends = () => import('./screens/friends.js');
  const clubs = () => import('./screens/clubs.js');
  const workshop = () => import('./screens/workshop.js');
  const store = () => import('./screens/store.js');
  const signin = () => import('./screens/signin.js');
  route('/', home, 'home');
  route('/play', play, 'play');
  route('/play/:with', play, 'play');
  route('/events', events, 'events');
  route('/events/:tab', events, 'events');
  route('/event/:id', events, 'events');
  route('/event/:id/:edit', events, 'events');
  route('/challenges', () => import('./screens/challenges.js'), 'challenges');
  route('/online', online, 'online');
  route('/online/:code', online, 'online');
  route('/watch/:watch', online, 'online'); // the param name tells the screen to watch, not to join
  route('/training', training, 'training');
  route('/training/:tab', training, 'training');
  route('/activities', activities, 'activities');
  route('/activity/:id', () => import('./screens/activity.js'), 'activities');
  route('/activity/:id/replay', () => import('./screens/replay.js'), 'activities');
  route('/progress', () => import('./screens/progress.js'), 'progress');
  route('/leaderboards', leaderboards, 'leaderboards');
  route('/leaderboards/:scope', leaderboards, 'leaderboards');
  route('/friends', friends, 'friends');
  route('/friends/add/:code', friends, 'friends');
  route('/club', clubs, 'club');
  route('/club/join/:code', clubs, 'club');
  route('/club/:id', clubs, 'club');
  route('/workshop', workshop, 'workshop');
  route('/workshop/create/:kind', workshop, 'workshop');
  route('/workshop/:id', workshop, 'workshop');
  route('/store', store, 'store');
  route('/store/:kind', store, 'store');
  route('/wardrobe', () => import('./screens/wardrobe.js'), 'wardrobe');
  route('/settings', () => import('./screens/settings.js'), 'settings');
  route('/settings/:tab', () => import('./screens/settings.js'), 'settings');
  route('/tutorials', () => import('./screens/tutorials.js'), 'tutorials');
  // terms, privacy policy, legal notice: readable before signing up
  route('/legal', () => import('./screens/legal.js'), 'settings');
  route('/legal/:page', () => import('./screens/legal.js'), 'settings');
  // return from Google or Strava
  route('/signin/:provider/error/:reason', signin, 'settings');
  route('/signin/:provider/:code', signin, 'settings');
  // the link of a password reset e-mail (ADR 0018), opened signed out
  route('/reset/:token', () => import('./screens/reset.js'), 'settings');
}
